export default {
  load_error_title: "Failed to load document",
  load_error_subtitle: "Sorry, the document could not be loaded. Please try again later.",
};
